import ResizeObserver from 'resize-observer-polyfill'

export default {
  mounted () {
    this.observeSize()
  },
  data () {
    return {
      width: window.innerWidth,
      height: 0
    }
  },
  computed: {
    isMobile () {
      if (this.width > 980) {
        return false
      }
      return true
    }
  },
  methods: {
    observeSize () {
      const ro = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const {
            width,
            height
          } = entry.contentRect
          this.width = width
          this.height = height
        })
      })

      ro.observe(this.$refs.targetElement)
    }
  }
}
